import { FaVideo } from 'react-icons/fa';
import ReactPlayer from 'react-player';
import { getImageUrls } from '../../util/image';
import { Carousel } from 'react-responsive-carousel';
import { minimumSize } from '../../util/ui';
import { PartialRecipe } from '../../types/api/entities/recipe';
import { FC, CSSProperties, useState } from 'react';

export interface MediaCarouselProps {
  recipe: PartialRecipe;
}

export const MediaCarousel: FC<MediaCarouselProps> = ({ recipe }) => {
  const [selectedItem, setSelectedItem] = useState(0);

  return (
    <div style={{ position: 'relative' }}>
      <Carousel
        showArrows={true}
        showStatus={false}
        showThumbs={false}
        showIndicators={false}
        selectedItem={selectedItem}
        onChange={setSelectedItem}
      >
        {recipe.media.map((media) => {
          if (media.type === 'image') {
            const urls = getImageUrls(media, '16x9');
            return (
              <img
                key={media.urls.original}
                alt={recipe.name}
                src={urls.src}
                srcSet={urls.srcSet}
                sizes={`(min-width: ${minimumSize.ExtraLarge}px) 890w, 100vw`}
                width="100%"
                height="100%"
              />
            );
          }

          return <ReactPlayer url={media.url} width="100%" height="100%" />;
        })}
      </Carousel>
      <div
        style={{
          position: 'absolute',
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          borderRadius: '20px',
          top: '20px',
          right: '20px',
          color: 'white',
          padding: '8px',
          fontSize: '.75em',
          fontFamily: 'sans-serif',
          display: 'flex',
          alignItems: 'center',
          userSelect: 'none',
          pointerEvents: 'none',
        }}
      >
        {selectedItem + 1}/{recipe.media.length}
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {recipe.media.map((media, index) => {
            const style: CSSProperties = {
              marginLeft: index === 0 ? 0 : '8px',
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
            };
            const color = selectedItem === index ? '#333' : '#999';

            if (media.type === 'image') {
              return (
                <div
                  key={index}
                  role="button"
                  style={{
                    ...style,
                    width: '10px',
                    height: '10px',
                    borderRadius: '50%',
                    backgroundColor: color,
                  }}
                  onClick={() => setSelectedItem(index)}
                />
              );
            }

            return (
              <FaVideo
                key={index}
                role="button"
                color={color}
                style={style}
                onClick={() => setSelectedItem(index)}
                size={14}
              />
            );
          })}
        </div>
      </div>
      <style jsx global>{`
        .carousel .slide iframe {
          width: 100%;
          margin: 0;
        }
      `}</style>
    </div>
  );
};
